import React from 'react';
import c from 'classnames';
import UserLink from '../../../User/Link';
import JoinGroupButton from '../../../JoinGroupButton';
import s from './GroupDetail.scss';
const GroupDetail = ({ group, className })=>{
    if (!group) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(className)
    }, /*#__PURE__*/ React.createElement(UserLink, {
        className: s['username'],
        usernameClassName: s['username-inner'],
        withTooltip: true,
        user: group
    }), /*#__PURE__*/ React.createElement(JoinGroupButton, {
        group: group
    }));
};
GroupDetail.displayName = 'GroupDetail';
export default GroupDetail;
